module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-dune-abstract-hayman-0.ba22060a.jpg";